import { AttributeEntryType } from '../constants/attribute-entry-type';
import { AttributeType } from '../constants/attribute-type';
import { DomainApiModel } from './domain.model';

export type AttributeApiModel = {
  id: number;
  name: string;
  description: string | null;
  minimumValue: number | null;
  maximumValue: number | null;
  entryType: AttributeEntryType;
  type: AttributeType;
  numberOfDecimals: number | null;
  defaultValue: string | number | null;
  values: string[] | null;
};

export type WithDomains = AttributeApiModel & { domains: DomainApiModel[] };

export enum AttributeRelationship {
  DOMAINS = 'DOMAINS',
}
